import {
    SET_TEST_CLICK,
    SET_TEST_DATA,
    SET_TEST_VALUE,
} from "../actions/pageActions";

const defaultState = {
    clicked: false,
    data: {},
    value: "",
};

const page = (state = defaultState, action = undefined) => {
    const {type} = action;
    switch (type) {
        case SET_TEST_CLICK: {
            return {
                ...state,
                clicked: !state.clicked
            }
        }
        case SET_TEST_DATA: {
            return {
                ...state,
                data: action.data
            }
        }
        case SET_TEST_VALUE: {
            return {
                ...state,
                value: action.value
            }
        }
        default:
            return state;
    }
};

export default page;